var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CartStore } from '../store/cart-store';
import { NavigationStore } from '../store/navigation-store';
import { NavigationHandlers } from './classes/NavigationHandlers';
import Sliders from './swiper-init';
export class CartService {
    constructor() {
        this.updatePriceLabel = () => {
            var _a, _b, _c, _d;
            const priceLabel = document.getElementById('js-price-label-update');
            const freeShippingText = document.getElementById('js-free-shipping-text');
            const freeShippingIcon = document.getElementById('js-free-shipping-icon');
            if (!priceLabel || !freeShippingText || !freeShippingIcon)
                return;
            const state = CartStore.getState();
            const freeShippingInfo = state === null || state === void 0 ? void 0 : state.freeShippingInfo;
            const freeShippingLocalization = state === null || state === void 0 ? void 0 : state.freeShippingLocalization;
            if (freeShippingInfo === null || freeShippingInfo === void 0 ? void 0 : freeShippingInfo.eligible) {
                freeShippingText.innerHTML = (_a = freeShippingLocalization === null || freeShippingLocalization === void 0 ? void 0 : freeShippingLocalization.cart_free_delivery_text_success) !== null && _a !== void 0 ? _a : '';
                freeShippingText.style.color = 'rgba(96, 186, 25, 1)';
                freeShippingIcon.style.filter = 'hue-rotate(55deg)';
                priceLabel.innerHTML = '';
            }
            else {
                freeShippingText.innerHTML = (_b = freeShippingLocalization === null || freeShippingLocalization === void 0 ? void 0 : freeShippingLocalization.cart_free_delivery_text) !== null && _b !== void 0 ? _b : '';
                freeShippingText.style.color = '';
                freeShippingIcon.style.filter = '';
                const formattedAmount = (_d = (_c = freeShippingInfo === null || freeShippingInfo === void 0 ? void 0 : freeShippingInfo.amount_remaining) === null || _c === void 0 ? void 0 : _c.formatted) !== null && _d !== void 0 ? _d : 'N/A';
                priceLabel.innerHTML = formattedAmount;
            }
        };
        this.updateCartCounter = () => {
            var _a;
            const cartCounter = document.getElementById('js-cart-counter');
            if (!cartCounter)
                return;
            const state = CartStore.getState();
            const cartItemCount = (_a = state === null || state === void 0 ? void 0 : state.cart_item_count) !== null && _a !== void 0 ? _a : 0;
            if (cartCounter instanceof HTMLElement) {
                cartCounter.innerHTML = String(cartItemCount);
                cartCounter.style.visibility = cartItemCount === 0 ? 'hidden' : 'visible';
            }
        };
        this.onWooCommerceCartUpdated = () => {
            CartStore.getState().setSkipNextCartTrack(true);
            NavigationStore.getState().open('Cart');
            const value = 1;
            CartStore.getState()
                .fetchCart()
                .then(() => {
                CartService.trackViewCartEvent();
            })
                .catch((error) => {
                console.error('Error fetching cart:', error);
            })
                .finally(() => {
                CartStore.getState().setSkipNextCartTrack(false);
            });
            this.updateCartCounter();
        };
        this.attachCartItemRemoveListeners = () => {
            jQuery(document.body)
                .off('click', '.js-cart-item-remove')
                .on('click', '.js-cart-item-remove', (event) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                event.preventDefault();
                const parentCartItem = event.currentTarget.closest('.cart-item');
                const itemKey = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-cart-item-key');
                const productId = (_a = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-id')) !== null && _a !== void 0 ? _a : '';
                const cartItemKey = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-cart-item-key');
                const productName = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-name');
                const productQuantity = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-quantity')) || 0;
                const pricePerItem = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-price-per-item')) || 0;
                const dataDiscount = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-discount-custom')) || 0;
                const total_removal_value = productQuantity * pricePerItem;
                if (!itemKey)
                    return;
                dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({ ecommerce: null });
                dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.push({
                    event: 'remove_from_cart',
                    ecommerce: {
                        currency: perlaData === null || perlaData === void 0 ? void 0 : perlaData.currency,
                        value: total_removal_value,
                        items: [
                            {
                                item_id: productId,
                                item_name: productName,
                                item_variant: '1 package',
                                price: pricePerItem,
                                discount_custom: dataDiscount,
                                quantity: productQuantity,
                                google_business_vertical: 'retail',
                            },
                        ],
                    },
                });
                yield this.removeCartItem(itemKey, productId);
            }));
        };
        this.onIncrementButtonClick = (event) => {
            var _a, _b;
            const button = event.currentTarget;
            const cartItem = button.closest('.cart-item');
            if (!cartItem)
                return;
            const productId = (_a = cartItem.getAttribute('data-product-id')) !== null && _a !== void 0 ? _a : '';
            const quantityElement = cartItem.querySelector('.quantity-value');
            if (!productId || !quantityElement)
                return;
            let quantity = parseInt(quantityElement.innerText, 10) || 0;
            quantity++;
            const parentCartItem = event.currentTarget.closest('.cart-item');
            const productName = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-name');
            const productQuantity = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-quantity')) || 0;
            const pricePerItem = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-price-per-item')) || 0;
            const dataDiscount = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-discount-custom')) || 0;
            quantityElement.innerText = quantity.toString();
            pushEcommerceEvent({
                eventName: 'add_to_cart',
                currency: (_b = perlaData === null || perlaData === void 0 ? void 0 : perlaData.currency) !== null && _b !== void 0 ? _b : '',
                value: pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : 0,
                items: [
                    {
                        item_id: productId !== null && productId !== void 0 ? productId : '',
                        item_name: productName !== null && productName !== void 0 ? productName : '',
                        item_variant: '1 package',
                        price: pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : 0,
                        discount_custom: dataDiscount,
                        quantity: 1,
                        google_business_vertical: 'retail',
                    },
                ],
            });
            this.incrementCartAjax(productId);
        };
        this.onAddCrossellButtonClick = (event) => {
            var _a;
            const button = event.currentTarget;
            const productId = button.getAttribute('data-product-id');
            if (!productId)
                return;
            const parentCartItem = event.currentTarget.closest('.suggestion-item');
            const productName = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-name');
            const productQuantity = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-quantity')) || 0;
            const pricePerItem = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-price-per-item')) || 0;
            const dataDiscount = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-discount-custom')) || 0;
            pushEcommerceEvent({
                eventName: 'add_to_cart',
                currency: (_a = perlaData === null || perlaData === void 0 ? void 0 : perlaData.currency) !== null && _a !== void 0 ? _a : '',
                value: pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : 0,
                items: [
                    {
                        item_id: productId !== null && productId !== void 0 ? productId : '',
                        item_name: productName !== null && productName !== void 0 ? productName : '',
                        item_variant: '1 package',
                        price: pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : 0,
                        discount_custom: dataDiscount,
                        quantity: 1,
                        google_business_vertical: 'retail',
                    },
                ],
            });
            this.incrementCartAjax(productId);
        };
        this.onDecrementButtonClick = (event) => {
            var _a, _b;
            const button = event.currentTarget;
            const cartItem = button.closest('.cart-item');
            if (!cartItem)
                return;
            const cartItemKey = cartItem.getAttribute('data-cart-item-key');
            const quantityElement = cartItem.querySelector('.quantity-value');
            if (!cartItemKey || !quantityElement)
                return;
            let quantity = parseInt(quantityElement.innerText, 10) || 0;
            const parentCartItem = event.currentTarget.closest('.cart-item');
            const productName = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-name');
            const productId = (_a = parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-id')) !== null && _a !== void 0 ? _a : '';
            const productQuantity = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-product-quantity')) || 0;
            const pricePerItem = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-price-per-item')) || 0;
            const dataDiscount = Number(parentCartItem === null || parentCartItem === void 0 ? void 0 : parentCartItem.getAttribute('data-discount-custom')) || 0;
            quantityElement.innerText = quantity.toString();
            pushEcommerceEvent({
                eventName: 'remove_from_cart',
                currency: (_b = perlaData === null || perlaData === void 0 ? void 0 : perlaData.currency) !== null && _b !== void 0 ? _b : '',
                value: pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : 0,
                items: [
                    {
                        item_id: productId !== null && productId !== void 0 ? productId : '',
                        item_name: productName !== null && productName !== void 0 ? productName : '',
                        item_variant: '1 package',
                        price: pricePerItem !== null && pricePerItem !== void 0 ? pricePerItem : 0,
                        discount_custom: dataDiscount,
                        quantity: 1,
                        google_business_vertical: 'retail',
                    },
                ],
            });
            if (quantity > 1) {
                quantity--;
                quantityElement.innerText = quantity.toString();
                this.decrementCartAjax(cartItemKey, productId);
            }
            else {
                this.removeCartItem(cartItemKey, productId);
            }
        };
        this.onStateChanged = (state) => {
            if (!this.container)
                return;
            if (!state.hasFetchedCart)
                return;
            this.container.innerHTML = '';
            if (state.isLoading) {
                this.container.innerHTML =
                    '<div class="animated-svg-container"><svg class="animated-svg" xmlns="http://www.w3.org/2000/svg" width="89" height="71" viewBox="0 0 89 71" fill="none">\n' +
                        '  <rect x="35.0605" y="48.4844" width="18.8788" height="13.4678" fill="white"/>\n' +
                        '  <path d="M54.1741 55.2257C77.555 50.9822 93.8518 32.9849 87.6889 20.9767C84.3215 14.3858 75.9349 15.9206 75.9349 15.9206C75.9349 15.9206 77.6186 8.36662 69.8673 4.63474C62.116 0.902872 55.6989 6.10944 55.6989 6.10944C55.6989 6.10944 52.8398 0.0300957 44.5167 0H44.485H44.4532C36.1301 0.0300957 33.271 6.10944 33.271 6.10944C33.271 6.10944 26.8857 0.842681 19.1344 4.60465C11.3831 8.33652 13.0668 15.8906 13.0668 15.8906C13.0668 15.8906 4.71196 14.3858 1.31282 20.9466C-4.85009 32.9548 11.4149 50.9521 34.8276 55.1956C16.1483 55.948 2.83767 58.9576 2.83767 62.539C2.83767 66.6621 21.4535 70.0328 44.4532 70.0328H44.485H44.5167C67.5165 70.0328 86.1323 66.6621 86.1323 62.539C86.164 58.9576 72.8217 55.948 54.1741 55.2257ZM44.5803 60.4924C40.7046 60.4924 37.5914 58.1751 37.5914 55.2859C37.5914 52.3967 40.7364 50.0793 44.5803 50.0793C48.4559 50.0793 51.5691 52.3967 51.5691 55.2859C51.5691 58.1751 48.4559 60.4924 44.5803 60.4924Z" fill="url(#paint0_linear_2263_29928)"/>\n' +
                        '  <defs>\n' +
                        '    <linearGradient id="paint0_linear_2263_29928" x1="44.5" y1="0" x2="44.5" y2="70.0328" gradientUnits="userSpaceOnUse">\n' +
                        '      <stop stop-color="#BBC2F6"/>\n' +
                        '      <stop offset="0.9997" stop-color="#BBC2F6"/>\n' +
                        '      <stop offset="0.9998" stop-color="#8CD6FF" stop-opacity="0"/>\n' +
                        '    </linearGradient>\n' +
                        '  </defs>\n' +
                        '</svg></div>';
                return;
            }
            if (state.error) {
                this.container.innerHTML = `<p>Error: ${state.error}</p>`;
                return;
            }
            this.container.innerHTML = this.renderCartHtml(state);
            Sliders.initCrossSellsSwiper();
            Sliders.initCartPromoSwiper();
            NavigationHandlers.initCloseButtons();
        };
        this.applyPromoCode = (promoCode) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!promoCode) {
                return;
            }
            const data = {
                action: 'woocommerce_apply_coupon_perla',
                coupon_code: promoCode,
            };
            if (window.perlaData.apply_coupon_nonce) {
                data.security = window.perlaData.apply_coupon_nonce;
            }
            try {
                const response = yield jQuery.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    method: 'POST',
                    data,
                });
                if (response && response.success) {
                    console.log('Coupon applied successfully.');
                    CartStore.setState({ promocodeStatus: 'success', promocode: (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.coupon_code });
                    yield CartStore.getState().fetchCart();
                }
                else {
                    console.log('Coupon error.');
                    CartStore.setState({
                        promocodeStatus: 'error',
                        promocodeStatusMessage: (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.message,
                        promocode: (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.coupon_code,
                    });
                    const errorMessage = ((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.message) || 'Failed to apply coupon.';
                    yield CartStore.getState().fetchCart();
                }
            }
            catch (error) {
                console.error('Try catech error.', error);
                yield CartStore.getState().fetchCart();
            }
        });
        this.removePromoCode = (promoCode) => __awaiter(this, void 0, void 0, function* () {
            if (!promoCode) {
                return;
            }
            if (CartStore.getState().promocodeStatus === 'error') {
                CartStore.setState({ promocodeStatus: '', promocodeStatusMessage: '', promocode: '' });
                console.log('removePromoCode if erronious');
            }
            if (CartStore.getState().promocodeStatus === 'success') {
                const data = {
                    action: 'woocommerce_remove_coupon_perla',
                    coupon_code: promoCode,
                };
                if (window.perlaData.apply_coupon_nonce) {
                    data.security = window.perlaData.apply_coupon_nonce;
                }
                const response = yield jQuery.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    method: 'POST',
                    data,
                });
                if (response && response.success) {
                    console.log('Coupon removed successfully.');
                    CartStore.setState({ promocodeStatus: '', promocode: '', promocodeStatusMessage: '' });
                    yield CartStore.getState().fetchCart();
                }
                else {
                    console.log('Coupon removal error.');
                    yield CartStore.getState().fetchCart();
                }
                console.log('removePromoCode if success');
                console.log(data);
            }
        });
        this.renderCartHtml = (state) => {
            return `
        <div class="header-cart-content-wrapper">
            <!-- Desktop close button -->
            ${this.renderDesktopCloseButton(state.cartHeading)}
            <!-- Mobile close button -->
            ${this.renderMobileCloseButton(state.cartHeading)}
          
            ${this.renderCartContent(state)}
        </div>
        ${state.checkoutButtonText
                ? `
                <div class="checkout-btn-wrapper">
                    ${this.renderOrderSummary(state.summary, state.cartTotalsLocalization)}
                    <a class="checkout-btn no-decorate lh-28" href="${state.checkoutButtonURL}">${state.checkoutButtonText}</a>
                </div>`
                : ''}
    `;
        };
        this.renderDesktopCloseButton = (cartHeading) => {
            return `
        <div class="header-cart-close-btn desktop-only">
            <p class="header-cart-heading h5">${cartHeading}</p>
            <svg class="header__icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1.00027 13" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
                <path d="M1 1L12.9997 13" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
            </svg>
        </div>
    `;
        };
        this.renderMobileCloseButton = (cartHeading) => {
            return `
        <div class="header-cart-close-btn mobile-only">
            <svg class="perla-mobile-logo" width="96" height="48" viewBox="0 0 96 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0019 31.7334V15.9384C15.0019 15.4147 14.988 15.0446 14.967 14.8421C14.9461 14.6326 14.8762 14.4231 14.7715 14.1997C14.5969 13.7597 14.15 13.5293 13.4238 13.5084C12.9001 13.4874 12.6348 13.2919 12.6348 12.9148C12.6348 12.5657 12.9071 12.3911 13.4587 12.3911H20.7837C22.5154 12.3911 24.0935 12.6076 25.525 13.0475C26.9565 13.4874 28.1854 14.1089 29.2049 14.9189C30.2244 15.7289 31.0135 16.6925 31.5861 17.8098C32.1517 18.927 32.438 20.149 32.438 21.4897C32.438 23.8569 31.5861 25.6794 29.8753 26.9572C28.1645 28.2351 25.7484 28.8775 22.6202 28.8775C22.1174 28.8775 21.6146 28.8635 21.1119 28.8286C20.6091 28.7937 20.1692 28.7448 19.7991 28.682C19.5547 28.6401 19.3313 28.6052 19.1288 28.5842C18.9193 28.5633 18.7726 28.5493 18.6888 28.5493C18.3188 28.5493 18.1302 28.7588 18.1302 29.1708V32.4527C18.1302 32.9764 18.1442 33.3465 18.1651 33.549C18.1861 33.7585 18.2419 33.961 18.3257 34.1565C18.4375 34.3939 18.6051 34.5685 18.8355 34.6662C19.0659 34.764 19.3662 34.8338 19.7363 34.8827C20.239 34.9036 20.4904 35.0992 20.4904 35.4762C20.4904 35.8254 20.2181 35.9999 19.6664 35.9999H13.4308C12.9071 35.9999 12.6417 35.8254 12.6417 35.4762C12.6417 35.1061 12.8931 34.9106 13.3959 34.8827C13.766 34.8408 14.0662 34.764 14.2827 34.6662C14.4992 34.5685 14.6668 34.4009 14.7785 34.1565C14.8902 33.9819 14.9531 33.7934 14.974 33.5839C14.9949 33.3744 15.0089 32.9973 15.0089 32.4527V31.7334H15.0019ZM20.4485 13.6061C19.5477 13.6061 18.9402 13.7248 18.612 13.9483C18.2838 14.1787 18.1163 14.5907 18.1163 15.1772V25.5886C18.1163 26.2869 18.4095 26.8036 18.9891 27.1318C19.5687 27.46 20.5183 27.6276 21.8311 27.6276C22.9693 27.6276 23.898 27.5298 24.6242 27.3343C25.3434 27.1388 26.0138 26.8106 26.6283 26.3497C28.2064 25.1696 28.9954 23.4519 28.9954 21.1964C28.9954 20.0373 28.7999 18.9899 28.4019 18.0611C28.0109 17.1324 27.4383 16.3364 26.6911 15.68C25.944 15.0236 25.0502 14.5139 23.9958 14.1508C22.9483 13.7877 21.7613 13.6061 20.4485 13.6061Z" fill="#19191B"/>
<path d="M36.0785 29.4083C35.8131 29.4921 35.6874 29.5968 35.6874 29.7016C35.6874 29.8971 35.7992 30.2462 36.0156 30.749C36.5603 31.95 37.3144 32.8997 38.278 33.591C39.2417 34.2823 40.2891 34.6244 41.4273 34.6244C42.2163 34.6244 42.9844 34.4429 43.7246 34.0798C44.4718 33.7167 45.1351 33.2069 45.7287 32.5506C45.8125 32.4388 45.9033 32.362 45.994 32.3201C46.0778 32.2782 46.1546 32.2573 46.2245 32.2573C46.5108 32.2573 46.6504 32.4109 46.6504 32.7181C46.6504 32.8508 46.5945 33.0044 46.4898 33.179C45.8544 34.0519 44.9745 34.7431 43.8433 35.2459C42.7191 35.7487 41.539 36.0001 40.317 36.0001C39.1788 36.0001 38.1244 35.7975 37.1678 35.3925C36.2042 34.9875 35.3732 34.4289 34.6749 33.7167C33.9766 33.0044 33.425 32.1595 33.034 31.1749C32.6429 30.1904 32.4404 29.115 32.4404 27.9559C32.4404 26.8805 32.615 25.875 32.9641 24.9323C33.3133 23.9896 33.8021 23.1796 34.4235 22.5023C35.045 21.825 35.7922 21.2873 36.658 20.8963C37.5239 20.5052 38.4596 20.3027 39.4651 20.3027C40.5614 20.3027 41.5739 20.5471 42.5026 21.0429C43.4313 21.5387 44.2483 22.244 44.9466 23.1587C45.3865 23.7243 45.7776 24.3737 46.1267 25.0929C46.2803 25.463 46.3571 25.7633 46.3571 25.9797C46.3571 26.1753 46.2594 26.3079 46.0639 26.3708L36.0785 29.4083ZM35.5198 28.3539C35.5827 28.3539 35.6804 28.319 35.8131 28.2561L42.9705 26.1543C43.2358 26.0915 43.3615 25.9658 43.3615 25.7912C43.3615 25.6795 43.3266 25.5119 43.2638 25.2815C43.2009 25.051 43.1101 24.7927 42.9984 24.5134C42.7121 23.7941 42.3071 23.1866 41.7834 22.7048C40.9525 21.9158 39.9749 21.5247 38.8576 21.5247C37.7194 21.5247 36.8186 21.9786 36.1483 22.8864C35.4779 23.7941 35.1498 25.0371 35.1498 26.6152C35.1498 27.1179 35.1847 27.5369 35.2475 27.8651C35.3173 28.1933 35.4081 28.3539 35.5198 28.3539Z" fill="#19191B"/>
<path d="M51.5992 21.5175L51.6341 23.9126C51.6341 24.0662 51.6551 24.143 51.697 24.143C51.7179 24.143 51.8297 24.0033 52.0252 23.717C52.2417 23.326 52.521 22.9489 52.8561 22.5998C53.1913 22.2507 53.5614 21.9434 53.9664 21.6781C54.3714 21.4127 54.7904 21.2102 55.2233 21.0566C55.6562 20.903 56.0962 20.8262 56.5291 20.8262C56.9201 20.8262 57.2902 20.882 57.6463 20.9868C57.9955 21.0985 58.3167 21.2382 58.596 21.4127C58.7496 21.4756 58.8264 21.5524 58.8264 21.6432C58.8264 21.7549 58.7915 21.8526 58.7287 21.9364C58.5122 22.4392 58.3167 22.935 58.1561 23.4308C57.9885 23.9195 57.8907 24.2757 57.8419 24.4991C57.8 24.7645 57.7301 24.939 57.6463 25.0438C57.5556 25.1415 57.4368 25.1904 57.2832 25.1904C57.0388 25.1904 56.9131 24.974 56.8922 24.534C56.8712 24.0732 56.7037 23.6961 56.3964 23.4028C56.0892 23.1095 55.6981 22.9629 55.2163 22.9629C54.7136 22.9629 54.2457 23.0816 53.8058 23.3051C53.3659 23.5355 52.9888 23.8497 52.6746 24.2547C52.3534 24.6597 52.102 25.1276 51.9204 25.6652C51.7319 26.2029 51.6411 26.7755 51.6411 27.39V33.1089C51.6411 33.7653 51.7529 34.2192 51.9833 34.4705C52.2137 34.7219 52.6536 34.9035 53.31 35.0152C53.7499 35.078 53.9664 35.2596 53.9664 35.5389C53.9664 35.8462 53.736 35.9998 53.2751 35.9998H47.3677C46.8859 35.9998 46.6484 35.8392 46.6484 35.504C46.6484 35.2666 46.8789 35.099 47.3397 35.0152C47.647 34.9733 47.9193 34.8965 48.1637 34.7848C48.4011 34.673 48.5687 34.5334 48.6595 34.3588C48.7922 34.2052 48.855 33.7932 48.855 33.1089V32.5503V25.9515C48.855 25.3161 48.7922 24.8832 48.6734 24.6527C48.5547 24.4223 48.3173 24.2617 47.9682 24.1779L47.7028 24.1151C47.5702 24.0941 47.4654 24.0383 47.3886 23.9475C47.3118 23.8637 47.2769 23.7589 47.2769 23.6542C47.2769 23.4796 47.3607 23.34 47.5422 23.2283L50.9987 21.0636C51.0406 21.0217 51.1035 21.0007 51.1942 21.0007C51.4386 20.9868 51.5783 21.1683 51.5992 21.5175Z" fill="#19191B"/>
<path d="M63.5855 12.5237V33.1788C63.5855 33.507 63.5995 33.7584 63.6344 33.933C63.6693 34.1075 63.7042 34.2542 63.7461 34.3589C63.9626 34.729 64.3606 34.9524 64.9262 35.0153C65.3871 35.0781 65.6175 35.2597 65.6175 35.539C65.6175 35.8462 65.3661 35.9999 64.8634 35.9999H59.5425C59.0607 35.9999 58.8232 35.8393 58.8232 35.5041C58.8232 35.2387 59.0537 35.0781 59.5145 35.0153C59.752 34.9524 59.9754 34.8686 60.1709 34.7709C60.3664 34.6731 60.5131 34.5335 60.5969 34.3589C60.7295 34.2053 60.7924 33.7793 60.7924 33.081V17.1882C60.7924 16.9927 60.7924 16.8111 60.7924 16.6436C60.7924 16.483 60.7784 16.3433 60.7575 16.2316C60.6946 15.666 60.3944 15.3098 59.8567 15.1772L59.6333 15.1143C59.3539 15.0724 59.2143 14.9188 59.2143 14.6535C59.2143 14.4998 59.312 14.3602 59.5076 14.2275L62.985 12.0628C63.0269 12.0209 63.0827 12 63.1456 12C63.397 12 63.5366 12.1746 63.5855 12.5237Z" fill="#19191B"/>
<path d="M66.2625 23.7121C66.3114 23.7052 66.3532 23.6912 66.3951 23.6702C66.5627 23.5865 66.7233 23.4677 66.8839 23.37C67.0655 23.2513 67.254 23.1396 67.4426 23.0278C67.8127 22.8044 68.1967 22.5879 68.5947 22.4273C69.9703 21.8687 71.8697 21.8687 73.0218 22.9231C73.0288 22.9301 73.0428 22.944 73.0498 22.951C73.6503 23.5236 74.1181 24.4942 74.4882 25.9187L74.6907 26.6868H73.8947C73.748 26.6868 73.5874 26.6868 73.4059 26.6798C70.9619 26.5541 67.8825 27.1826 66.3951 29.3193C65.5363 30.5553 65.3338 32.3499 66.06 33.6905C67.0585 35.541 69.0905 36.0926 71.0597 35.9041C72.9031 35.7295 74.558 35.0382 76.1082 34.0537L76.583 33.7534L76.9252 34.1863C77.3512 34.717 77.8818 35.2547 78.4963 35.555C79.1527 35.8762 79.8929 36.0298 80.6191 35.9949C81.2056 35.9669 81.8271 35.8063 82.3508 35.541C82.7279 35.3455 83.084 35.0592 83.2795 34.6751C83.3843 34.4726 83.4611 33.8861 83.0701 33.9699C82.9932 33.9838 82.9234 34.0257 82.8536 34.0537C82.5394 34.1863 82.1763 34.1724 81.8551 34.0606C81.7643 34.0257 81.6735 33.9838 81.5827 33.9419C81.3732 33.8302 81.1777 33.6766 81.0031 33.516C80.9473 33.4671 80.8984 33.4112 80.8495 33.3624C80.6051 33.104 80.4026 32.8247 80.242 32.5593C79.837 31.882 79.5926 31.1279 79.3552 30.3807C78.9432 29.1029 78.5312 27.825 78.1193 26.5472C77.6793 25.1715 77.2185 23.768 76.3875 22.5879C75.389 21.1704 73.8807 20.3115 72.142 20.3115C70.3544 20.3115 68.5808 20.8073 67.1423 21.9036C66.8281 22.148 65.5572 23.1675 66.032 23.6563C66.0949 23.7052 66.1787 23.7191 66.2625 23.7121ZM74.956 33.6975C73.9435 34.3539 72.6936 34.6193 71.5135 34.3469C70.913 34.2073 70.3544 33.9 69.9005 33.4881C69.2022 32.8596 68.8461 32.0496 68.8461 31.065C68.8461 30.0036 69.2371 29.1308 70.0052 28.4884C70.7384 27.8739 71.716 27.5527 72.9101 27.5527C73.5735 27.5527 74.0902 27.6504 74.4882 27.8529C74.9421 28.0904 75.2703 28.4814 75.4309 29.0121L75.9406 30.7787C76.0035 31.0231 76.0384 31.2256 76.0593 31.3653C76.0803 31.498 76.0942 31.6306 76.1152 31.8122C76.1571 32.2311 76.0104 32.6362 75.7661 32.9643C75.5426 33.2646 75.2563 33.502 74.956 33.6975Z" fill="#19191B"/>
</svg>

            <svg class="header__icon-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M16 4L8 12L16 20" stroke="#19191B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    `;
        };
        this.attachPromoCodeListener = () => {
            jQuery(document).on('click', '#apply-promo-btn', (event) => {
                const promoCodeInput = document.getElementById('promo-code-input');
                if (!promoCodeInput) {
                    console.error('Promo code input element not found.');
                    return;
                }
                const promoCode = promoCodeInput.value.trim();
                if (promoCode) {
                    this.applyPromoCode(promoCode);
                }
            });
        };
        this.attachRemovePromoCodeListener = () => {
            jQuery(document).on('click', '#remove-promo-btn', (event) => {
                event.preventDefault();
                const promoCodeInput = document.getElementById('promo-code-input');
                if (!promoCodeInput) {
                    console.error('Promo code input element not found.');
                    return;
                }
                const promoCode = promoCodeInput.value.trim();
                this.removePromoCode(promoCode);
                promoCodeInput.value = '';
            });
        };
        this.renderCartContent = (state) => {
            if (state.cartItems.length === 0) {
                return `
            <div class="shopping-cart px-8">
                ${this.renderCartSubHeader(state.promoSliderData)}
            </div>
            <div class="empty-text-wrapper">
                <p class='empty-cart-text'>${state.cartEmptyMessage}</p>
                <svg class="empty-cart-icon" xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64' fill='none'>
                    <path d='M11.9077 57.6691L13.6362 56.6629H13.6362L11.9077 57.6691ZM31.7242 61.9929L31.713 63.9928L31.7242 61.9929ZM10.2328 14.4198C9.6296 15.3451 9.89079 16.5842 10.8161 17.1874C11.7415 17.7906 12.9806 17.5294 13.5837 16.604L10.2328 14.4198ZM22.3911 3.09212C22.9942 2.16677 22.7331 0.927669 21.8077 0.324508C20.8824 -0.278653 19.6433 -0.0174689 19.0401 0.90788L22.3911 3.09212ZM49.8347 16.5548C50.4107 17.4973 51.6416 17.7945 52.5841 17.2185C53.5267 16.6425 53.8238 15.4116 53.2479 14.469L49.8347 16.5548ZM44.991 0.957137C44.415 0.0146151 43.1841 -0.282544 42.2415 0.293414C41.299 0.869372 41.0019 2.10034 41.5778 3.04286L44.991 0.957137ZM26.5688 40.9143C26.5688 39.8097 25.6734 38.9143 24.5688 38.9143C23.4642 38.9143 22.5688 39.8097 22.5688 40.9143H26.5688ZM22.5688 48.481C22.5688 49.5855 23.4642 50.481 24.5688 50.481C25.6734 50.481 26.5688 49.5855 26.5688 48.481H22.5688ZM41.9817 40.9143C41.9817 39.8097 41.0862 38.9143 39.9817 38.9143C38.8771 38.9143 37.9817 39.8097 37.9817 40.9143H41.9817ZM37.9817 48.481C37.9817 49.5855 38.8771 50.481 39.9817 50.481C41.0862 50.481 41.9817 49.5855 41.9817 48.481H37.9817ZM9.70642 17.5119H54.2936V13.5119H9.70642V17.5119ZM54.2936 28.6452H9.70642V32.6452H54.2936V28.6452ZM9.70642 28.6452C6.52019 28.6452 4 26.1186 4 23.0786H0C0 28.3965 4.38038 32.6452 9.70642 32.6452V28.6452ZM60 23.0786C60 26.1186 57.4798 28.6452 54.2936 28.6452V32.6452C59.6196 32.6452 64 28.3965 64 23.0786H60ZM54.2936 17.5119C57.4798 17.5119 60 20.0385 60 23.0786H64C64 17.7607 59.6196 13.5119 54.2936 13.5119V17.5119ZM9.70642 13.5119C4.38038 13.5119 0 17.7607 0 23.0786H4C4 20.0385 6.52019 17.5119 9.70642 17.5119V13.5119ZM5.85321 29.9171C3.88779 30.2874 3.88781 30.2875 3.88785 30.2877C3.88789 30.2879 3.88795 30.2882 3.88803 30.2887C3.88818 30.2895 3.88841 30.2907 3.88871 30.2923C3.88931 30.2955 3.89021 30.3002 3.89139 30.3064C3.89374 30.319 3.89725 30.3375 3.90187 30.362C3.91112 30.4109 3.92483 30.4834 3.94275 30.578C3.97858 30.7671 4.03124 31.0445 4.09866 31.3981C4.23351 32.1053 4.42744 33.1175 4.66395 34.3386C5.13687 36.7802 5.78051 40.0593 6.46272 43.4057C7.14431 46.7491 7.86707 50.1727 8.49789 52.8985C8.81282 54.2593 9.10904 55.4647 9.36896 56.4063C9.49861 56.876 9.62442 57.2991 9.74379 57.6522C9.84959 57.9651 9.99316 58.3556 10.1793 58.6753L13.6362 56.6629C13.6696 56.7203 13.6323 56.6644 13.5331 56.371C13.4475 56.1178 13.3442 55.7746 13.2248 55.342C12.9866 54.4791 12.7048 53.336 12.3949 51.9967C11.776 49.3223 11.0615 45.9391 10.3821 42.6067C9.70338 39.2774 9.06241 36.012 8.59097 33.5779C8.35529 32.3612 8.1621 31.3528 8.02787 30.6489C7.96076 30.2969 7.90839 30.0211 7.87283 29.8334C7.85505 29.7395 7.84147 29.6677 7.83235 29.6195C7.82779 29.5953 7.82435 29.5771 7.82205 29.5649C7.8209 29.5588 7.82004 29.5543 7.81947 29.5512C7.81919 29.5497 7.81897 29.5486 7.81883 29.5479C7.81876 29.5475 7.81871 29.5472 7.81868 29.547C7.81865 29.5469 7.81864 29.5468 5.85321 29.9171ZM53.8734 58.5766C54.5329 57.2816 55.0958 55.4576 55.6043 53.4225C56.1218 51.3515 56.617 48.9169 57.1042 46.3218C58.0903 41.0692 59.0326 35.2358 60.1065 29.9635L56.187 29.1651C55.1113 34.4463 54.1267 40.5033 53.1729 45.5838C52.6901 48.1553 52.2121 50.4979 51.7236 52.4529C51.2262 54.4438 50.7504 55.8947 50.309 56.7615L53.8734 58.5766ZM10.1793 58.6753C11.0361 60.1471 12.4987 61.1115 14.0257 61.7707C15.5775 62.4406 17.4207 62.8922 19.3466 63.2068C23.2005 63.8364 27.7386 63.9705 31.713 63.9928L31.7355 59.9929C27.7824 59.9707 23.5134 59.8345 19.9915 59.2592C18.2295 58.9713 16.7427 58.5868 15.6111 58.0983C14.4546 57.599 13.8805 57.0827 13.6362 56.6629L10.1793 58.6753ZM31.713 63.9928C35.7543 64.0156 40.4464 64.0202 44.4182 63.4492C46.4062 63.1634 48.3227 62.7197 49.9362 62.003C51.5431 61.2892 53.0369 60.2194 53.8734 58.5766L50.309 56.7615C50.0446 57.2807 49.4592 57.838 48.3124 58.3474C47.1722 58.8539 45.6603 59.2295 43.849 59.4899C40.2221 60.0113 35.8316 60.016 31.7355 59.9929L31.713 63.9928ZM13.5837 16.604L22.3911 3.09212L19.0401 0.90788L10.2328 14.4198L13.5837 16.604ZM53.2479 14.469L44.991 0.957137L41.5778 3.04286L49.8347 16.5548L53.2479 14.469ZM22.5688 40.9143V48.481H26.5688V40.9143H22.5688ZM37.9817 40.9143V48.481H41.9817V40.9143H37.9817Z'
                          fill='#84878C'/>
                </svg>
            </div>
            <div class='shop-button-wrapper'>
                <a class='checkout-btn no-decorate' href="${state.goToShopLink}">${state.goToShopButtonText}</a>
            </div>
            `;
            }
            const freeDeliveryOffer = (state === null || state === void 0 ? void 0 : state.hideFreeDeliveryOffer)
                ? ''
                : this.renderCartHeader(state.freeShippingInfo, state.freeShippingLocalization);
            return `
            <div class="shopping-cart px-8">
                ${freeDeliveryOffer}
                ${this.renderCartSubHeader(state.promoSliderData)}
                ${this.renderCartItems(state)}
            </div>
            <div class="shopping-cart">
                ${this.renderSuggestions(state.crossSells, state.crossSellLocalization)}
            </div>
            <div class="shopping-cart px-8">
                ${this.renderPromoCodeSection()}
            </div>
        `;
        };
        this.renderCartSubHeader = (promoSliderData) => {
            if (promoSliderData.length === 0) {
                return '';
            }
            return `
        <div class="swiper-container cart-promo-card">
            <div class="swiper-wrapper promo-card-width-limit">
                ${promoSliderData
                .map((item) => `
                    <div class="swiper-slide promo-card-wrapper">
                    <div class="promo-card">
                        <div class="promo-card__icon">
                            <img src="${item.icon.src}" alt="${item.icon.alt}">
                        </div>
                        <div class="promo-card__content">
                            <p class="promo-card__title">${item.heading}</p>
                            <p class="promo-card__description">${item.subheading}</p>
                            <button class="promo-card__button" onclick="window.location.href='${item.button_url}'">
                                ${item.button_text}
                            </button>
                        </div>
                    </div>
                    </div>
                `)
                .join('')}
            </div>
            <div class="swiper-pagination"></div>
        </div>
    `;
        };
        this.renderStars = (rating) => {
            const starCount = Math.max(0, Math.round(rating));
            const starSVG = `
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M11.456 4.54107C11.4056 4.41273 11.315 4.30204 11.1963 4.2238C11.0777 4.14556 10.9366 4.10351 10.792 4.10326H7.91857C7.86966 4.10329 7.82193 4.08897 7.78197 4.06225C7.74201 4.03553 7.71176 3.99774 7.6954 3.95407L6.66424 1.18775C6.6141 1.0593 6.52362 0.948483 6.40498 0.870219C6.28635 0.791956 6.14525 0.75 6.00068 0.75C5.85611 0.75 5.71501 0.791956 5.59637 0.870219C5.47773 0.948483 5.38725 1.0593 5.33711 1.18775L5.33474 1.1945L4.30595 3.95407C4.28954 3.99756 4.25939 4.03521 4.21961 4.0619C4.17982 4.08859 4.13233 4.10303 4.08357 4.10326H1.20931C1.06385 4.10275 0.921778 4.14477 0.802469 4.22359C0.683159 4.3024 0.592429 4.41418 0.542658 4.54365C0.492888 4.67312 0.486503 4.81399 0.524374 4.94703C0.562245 5.08007 0.642528 5.19879 0.754266 5.28701L3.20198 7.20769C3.23839 7.23663 3.26479 7.27524 3.27777 7.31855C3.29075 7.36185 3.28971 7.40785 3.27479 7.45059L2.2468 10.3676C2.19922 10.5026 2.19827 10.6485 2.24407 10.7841C2.28987 10.9196 2.38005 11.0379 2.50155 11.1217C2.62304 11.2054 2.76953 11.2504 2.91979 11.25C3.07006 11.2496 3.2163 11.2039 3.33731 11.1195L5.861 9.36902C5.90154 9.34094 5.95046 9.3258 6.00068 9.3258C6.0509 9.3258 6.09982 9.34094 6.14035 9.36902L8.66325 11.1195C8.78446 11.2031 8.93052 11.2482 9.08046 11.2482C9.2304 11.2483 9.37649 11.2033 9.49774 11.1198C9.619 11.0362 9.70917 10.9184 9.75532 10.7833C9.80146 10.6481 9.8012 10.5026 9.75456 10.3676L8.72656 7.44834C8.71138 7.40574 8.7102 7.35978 8.7232 7.31654C8.73621 7.2733 8.76277 7.23482 8.79937 7.20619L11.2518 5.28251C11.362 5.19364 11.4406 5.07486 11.4771 4.94224C11.5137 4.80963 11.5063 4.66959 11.456 4.54107Z" fill="#F4C41B"/>
            </svg>
        `;
            return Array.from({ length: starCount }, () => starSVG).join('');
        };
        this.renderCartItems = (state) => {
            return state.cartItems.map((item) => this.renderCartItem(item, state.lateDeliveryLocalization)).join('');
        };
        this.renderCartItem = (item, lateDeliveryLocalization) => `
        <div class="cart-item" 
            data-product-id="${item.product_id}" 
            data-cart-item-key="${item.cart_item_key}"
            data-product-quantity="${item.quantity}"
            data-product-name="${item.product_name}"
            data-discount-custom="${item.discount_custom}"
            data-price-per-item="${CartService.removeHtmlEntitiesAndNonDigits(item.price_per_item)}"
        >
            <div class="cart-item-remove js-cart-item-remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" class="cart-item-remove-icon" height="8" viewBox="0 0 24 24" fill="none">
                <path d="M5 19L12 12L19 19M19 5L11.9987 12L5 5" stroke="#B0B0B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </div>
            <div class="cart-item-flex-content">
                <div class="item-image-container">
                    ${item.sale_percentage ? `<div class="discount-badge">${item.sale_percentage}</div>` : ''}
                    <div class="item-image">
                        <a href="${item.product_url}">
                            ${item.product_image}
                        </a>
                    </div>
                </div>
                <div class="item-details">
                    <h3 class="item-title">${item.product_name}</h3>
                    <div class="item-rating">
                        ${this.renderStars(item.review_rating)}
                        <span>${item.review_rating > 0 ? `${item.review_rating}` : ''}</span>
                    </div>
                    <div class="item-description">
                        <span>${item.short_description}</span>
                    </div>
                    <div class="flex-wrapper">
                        <div class="item-quantity">
                            <button class="quantity-btn decrement-cart-item">−</button>
                            <span class="quantity-value">${item.quantity}</span>
                            <button class="quantity-btn ajax_add_to_cart">+</button>
                        </div>
                        <div class="item-price">
                          ${item.price_per_item && item.price_per_item !== item.regular_price
            ? `<span class="original-price">${item.regular_price}</span>
                               <span class="discounted-price">${item.price_per_item}</span>`
            : `<span class="discounted-price">${item.price_per_item || item.regular_price}</span>`}
                        </div>
                    </div>
                </div>
            </div>
           ${item.late_delivery
            ? `
                <div class="item-late-delivery">
                    ${lateDeliveryLocalization} ${item.late_delivery}
                </div>`
            : ''}
        </div>
    `;
        this.renderSuggestions = (crossSells, crossSellsLocalization) => crossSells.length > 0
            ? `
    <div class="suggestions">
        <h4>${crossSellsLocalization === null || crossSellsLocalization === void 0 ? void 0 : crossSellsLocalization.heading}</h4>
        <p>${crossSellsLocalization === null || crossSellsLocalization === void 0 ? void 0 : crossSellsLocalization.subheading}</p>
        <div class="swiper-container suggestion-items">
            <div class="swiper-wrapper">
                ${crossSells
                .map((item) => {
                var _a;
                return `
                            <div class="swiper-slide suggestion-item" style="background: ${item.cross_sell_color}" 
                                            data-product-id="${item.product_id}" 
                                            data-product-quantity="1" 
                                            data-product-name="${item.product_name}" 
                                            data-price-per-item="${(_a = Number(CartService.removeHtmlEntitiesAndNonDigits(item.price))) !== null && _a !== void 0 ? _a : 0}">
                                <a href="${item.product_url}">
                                 <img src="${item.product_image}" alt="${item.product_name}">
                                </a>
                                <p class="suggestion-name">${item.product_name}</p>
                                <p class="suggestion-price">${item.price}</p>
                                <button class="add-btn js-add-crossel-button" data-product-id="${item.product_id}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.79995 3.49995C8.79995 3.05812 8.44178 2.69995 7.99995 2.69995C7.55812 2.69995 7.19995 3.05812 7.19995 3.49995V7.19995H3.49995C3.05812 7.19995 2.69995 7.55812 2.69995 7.99995C2.69995 8.44178 3.05812 8.79995 3.49995 8.79995L7.19995 8.79995V12.5C7.19995 12.9418 7.55812 13.3 7.99995 13.3C8.44178 13.3 8.79995 12.9418 8.79995 12.5V8.79995L12.5 8.79995C12.9418 8.79995 13.3 8.44178 13.3 7.99995C13.3 7.55812 12.9418 7.19995 12.5 7.19995H8.79995V3.49995Z" fill="white"/>
                                    </svg>
                                    <span>${crossSellsLocalization === null || crossSellsLocalization === void 0 ? void 0 : crossSellsLocalization.button_text}</span>
                                </button>
                            </div>
                        `;
            })
                .join('')}
            </div>
        </div>
    </div>
    `
            : '';
        this.renderPromoCodeSection = () => {
            var _a;
            const { promocodeLocalization = { placeholder: '', promocode_note: '' }, promocode, promocodeStatus, promocodeStatusMessage, } = (_a = CartStore.getState()) !== null && _a !== void 0 ? _a : {};
            const isSuccessOrError = promocodeStatus === 'success' || promocodeStatus === 'error';
            return `
    <div class="promo-code-section perla-form">
        <div class="input-container pos-r${promocodeStatus ? ` ${promocodeStatus}` : ''}">
            <input type="text" class="input input-text" id="promo-code-input" placeholder="" ${promocode ? `value="${promocode}"` : ''}>
            <label for="text" class="label">${promocodeLocalization === null || promocodeLocalization === void 0 ? void 0 : promocodeLocalization.placeholder}</label>
            ${isSuccessOrError
                ? `
                            <button id="remove-promo-btn" class="remove-btn apply-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.79278 6.66134C7.48036 6.34892 6.97383 6.34892 6.66141 6.66134C6.34899 6.97376 6.34899 7.4803 6.66141 7.79271L10.8687 12L6.66141 16.2073C6.34899 16.5197 6.34899 17.0262 6.66141 17.3387C6.97383 17.6511 7.48036 17.6511 7.79278 17.3387L12.0001 13.1314L16.2074 17.3387C16.5198 17.6511 17.0263 17.6511 17.3387 17.3387C17.6511 17.0262 17.6511 16.5197 17.3387 16.2073L13.1314 12L17.3387 7.79271C17.6511 7.4803 17.6511 6.97376 17.3387 6.66134C17.0263 6.34892 16.5198 6.34892 16.2074 6.66134L12.0001 10.8686L7.79278 6.66134Z" fill="white"/>
                            </svg>
                            </button>
                        `
                : `
                            <button id="apply-promo-btn" class="apply-btn">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="24" height="24" 
                                    viewBox="0 0 24 24" fill="none"
                                >
                                    <path 
                                        fill-rule="evenodd" 
                                        clip-rule="evenodd" 
                                        d="M12.8 5.24995C12.8 4.80812 12.4418 4.44995 12 4.44995C11.5582 4.44995 11.2 4.80812 11.2 5.24995V11.2H5.25001C4.80818 11.2 4.45001 11.5581 4.45001 12C4.45001 12.4418 4.80818 12.8 5.25001 12.8H11.2V18.75C11.2 19.1918 11.5582 19.55 12 19.55C12.4418 19.55 12.8 19.1918 12.8 18.75V12.8H18.75C19.1918 12.8 19.55 12.4418 19.55 12C19.55 11.5581 19.1918 11.2 18.75 11.2H12.8V5.24995Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                        `}
            ${promocodeStatus === 'error' ? `<div class="desc">${promocodeStatusMessage}</div>` : ''}
        </div>
        <p class="promo-note">${promocodeLocalization === null || promocodeLocalization === void 0 ? void 0 : promocodeLocalization.promocode_note}</p>
    </div>
    `;
        };
        this.renderOrderSummary = (summary, cartTotalsLocalization) => `
    <div class="order-summary">
        <p class="summary-heading">${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.order_summary) || ''}</p>
        <div class="summary-item">
            <span>${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.products) || ''}</span>
            <span>${(summary === null || summary === void 0 ? void 0 : summary.cart_contents_total) || ''}</span>
        </div>
        <div class="summary-item">
            <span>${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.discount) || ''}</span>
            <span class="discounted-price">
                ${this.formatDiscount(summary === null || summary === void 0 ? void 0 : summary.total_discount)}
            </span>
        </div>
        <div class="summary-total">
            <span>${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.total) || ''}</span>
            <span>${(summary === null || summary === void 0 ? void 0 : summary.total_order_price) || ''}</span>
        </div>
    </div>
`;
        this.formatDiscount = (totalDiscount) => {
            const discount = parseFloat(totalDiscount || '0');
            return discount > 0 ? `-${totalDiscount}` : '';
        };
        this.renderOrderSummaryAlt = (summary, cartTotalsLocalization) => `
  <div class="order-summary">
    <p class="summary-heading">${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.order_summary) || ''}</p>
    <div class="summary-item">
      <span>Products Subtotal</span>
      <span>${(summary === null || summary === void 0 ? void 0 : summary.products_subtotal) || ''}</span>
    </div>
    <div class="summary-item">
      <span>${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.discount) || ''}</span>
      <span class="discounted-price">${(summary === null || summary === void 0 ? void 0 : summary.total_discount) || ''}</span>
    </div>
    <div class="summary-item last">
      <span>${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.shipping_total) || ''}</span>
      <span>${(summary === null || summary === void 0 ? void 0 : summary.delivery_cost) || ''}</span>
    </div>
    <div class="summary-total">
      <span>${(cartTotalsLocalization === null || cartTotalsLocalization === void 0 ? void 0 : cartTotalsLocalization.total) || ''}</span>
      <span>${(summary === null || summary === void 0 ? void 0 : summary.total_order_price) || ''}</span>
    </div>
  </div>
`;
        this.container = document.querySelector('.header-cart-wrapper');
    }
    init() {
        this.onStateChanged(CartStore.getState());
        CartStore.subscribe(this.onStateChanged);
        this.attachWooCommerceAjaxListeners();
        this.attachQuantityButtonListeners();
        this.attachPromoCodeListener();
        this.attachRemovePromoCodeListener();
        this.attachCartItemRemoveListeners();
        CartStore.subscribe(() => {
            this.updateCartCounter();
        });
        this.updateCartCounter();
        console.log('CartService init perladata currency', perlaData.currency);
        const { currency: currentCurrency, language: currentLanguage } = CartStore.getState();
        if (currentCurrency !== perlaData.currency) {
            console.log('Currency mismatch detected. Updating CartStore currency from', currentCurrency, 'to', perlaData.currency);
            CartStore.setState({ currency: perlaData.currency });
            console.log('CartService: fetching cart due to currency mismatch');
            CartStore.getState().fetchCart();
        }
        if (currentLanguage !== perlaData.language) {
            console.log('Language mismatch detected. Updating CartStore language from', currentLanguage, 'to', perlaData.language);
            CartStore.setState({ language: perlaData.language });
            console.log('CartService: clearing cart due to language mismatch');
            this.clearCart();
        }
        console.log('CartService init cartstate language:', CartStore.getState().language);
        console.log('CartService init cartstate currency:', CartStore.getState().currency);
    }
    attachWooCommerceAjaxListeners() {
        jQuery(document.body).on('added_to_cart', this.onWooCommerceCartUpdated);
    }
    static trackViewCartEvent() {
        var _a, _b, _c, _d;
        const items = CartStore.getState().cartItems;
        const total = (_b = (_a = CartStore.getState().summary) === null || _a === void 0 ? void 0 : _a.total_order_price) !== null && _b !== void 0 ? _b : '0';
        let items_tranfromed;
        items_tranfromed = CartService.transformCartItems(items);
        pushEcommerceEvent({
            eventName: 'view_cart',
            currency: (_c = perlaData === null || perlaData === void 0 ? void 0 : perlaData.currency) !== null && _c !== void 0 ? _c : '',
            value: (_d = Number(CartService.removeHtmlEntitiesAndNonDigits(total))) !== null && _d !== void 0 ? _d : 0,
            items: items_tranfromed,
        });
    }
    static transformCartItems(cartItems) {
        return cartItems.map((item) => {
            var _a, _b, _c, _d;
            return ({
                item_id: (_b = (_a = item.product_id) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                item_name: (_c = item.product_name) !== null && _c !== void 0 ? _c : '',
                item_variant: '1 package',
                price: CartService.removeHtmlEntitiesAndNonDigits(item.price_per_item),
                discount_custom: item.discount_custom,
                quantity: (_d = item.quantity) !== null && _d !== void 0 ? _d : 1,
                google_business_vertical: 'retail',
            });
        });
    }
    manageSlider(presetValue) {
        const icon = document.getElementById('icon');
        const sliderBar = document.getElementById('sliderBar');
        const sliderContainer = document.querySelector('.slider-container');
        if (!icon || !sliderBar || !sliderContainer) {
            console.error('Slider elements not found in the DOM.');
            return;
        }
        const sliderWidth = sliderContainer.offsetWidth;
        if (sliderWidth === 0) {
            console.error('Slider container has zero width. Ensure it is visible.');
            return;
        }
        const updateSlider = (value) => {
            const iconPosition = (value / 100) * sliderWidth;
            icon.style.left = `${iconPosition}px`;
            const gradientWidth = (iconPosition / sliderWidth) * 100;
            sliderBar.style.setProperty('--gradient-width', `${gradientWidth}%`);
            sliderBar.style.background = `linear-gradient(to right, #fff, #000 ${gradientWidth}%, #E9EAED ${gradientWidth}%)`;
        };
        updateSlider(presetValue);
    }
    attachQuantityButtonListeners() {
        jQuery(document.body).on('click', '.ajax_add_to_cart', this.onIncrementButtonClick);
        jQuery(document.body).on('click', '.decrement-cart-item', this.onDecrementButtonClick);
        jQuery(document.body).on('click', '.js-add-crossel-button', this.onAddCrossellButtonClick);
    }
    incrementCartAjax(productId) {
        if (typeof woocommerce_params === 'undefined' || !woocommerce_params.wc_ajax_url) {
            console.error('WooCommerce parameters not found.');
            return;
        }
        const ajaxUrl = woocommerce_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart');
        jQuery.ajax({
            url: ajaxUrl,
            method: 'POST',
            data: {
                product_id: productId,
                quantity: 1,
            },
            success: () => {
                CartStore.getState().fetchCart();
            },
            error: () => {
                console.error('Failed to increment the cart item.');
            },
        });
    }
    decrementCartAjax(cartItemKey, productId) {
        jQuery.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'decrement_cart_item',
                cart_item_key: cartItemKey,
                product_id: productId,
            },
            success: () => {
                CartStore.getState().fetchCart();
            },
            error: () => {
                console.error('Failed to decrement the cart item.');
            },
        });
    }
    removeCartItem(cartItemKey, productId) {
        jQuery.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'remove_cart_item',
                cart_item_key: cartItemKey,
                product_id: productId,
            },
            success: () => {
                CartStore.getState().fetchCart();
            },
            error: () => {
                CartStore.getState().fetchCart();
            },
        });
    }
    clearCart() {
        jQuery.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'clear_cart',
            },
            success: () => {
                CartStore.getState().fetchCart();
                console.log('Cart successfully cleared');
            },
            error: () => {
                CartStore.getState().fetchCart();
            },
        });
    }
    renderCartHeader(freeShippingInfo, freeShippingLocalization) {
        var _a, _b, _c;
        const { free_shipping_threshold, amount_remaining, eligible } = freeShippingInfo;
        const thresholdAmount = (_a = free_shipping_threshold === null || free_shipping_threshold === void 0 ? void 0 : free_shipping_threshold.raw) !== null && _a !== void 0 ? _a : '0';
        const remainingAmount = (_b = amount_remaining === null || amount_remaining === void 0 ? void 0 : amount_remaining.raw) !== null && _b !== void 0 ? _b : 0;
        const presetValue = Math.min(100, Math.max(0, ((thresholdAmount - remainingAmount) / thresholdAmount) * 100));
        function isValidLocalization(localization) {
            return ((localization === null || localization === void 0 ? void 0 : localization.cart_free_delivery_text_success) !== undefined &&
                (localization === null || localization === void 0 ? void 0 : localization.cart_free_delivery_text) !== undefined &&
                (localization === null || localization === void 0 ? void 0 : localization.cart_free_delivery_text_additional) !== undefined);
        }
        const isLocalizationValid = isValidLocalization(freeShippingLocalization);
        const headerHTML = `
        <div class="cart-header">
            <p id="js-delivery-progress-heading-text">
                ${eligible && isLocalizationValid
            ? freeShippingLocalization.cart_free_delivery_text_success
            : isLocalizationValid
                ? `${freeShippingLocalization.cart_free_delivery_text} <span class="highlight">${(_c = amount_remaining === null || amount_remaining === void 0 ? void 0 : amount_remaining.formatted) !== null && _c !== void 0 ? _c : '0 zł'}</span> ${freeShippingLocalization.cart_free_delivery_text_additional}`
                : ''}
            </p>
            <div class="delivery-progress-bar">
                <div class="slider-container">
                    <div class="icon-container" id="icon">
                        <span class="icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.97859 3.66577C1.64406 3.66577 1.37793 3.94292 1.37793 4.27849C1.37793 4.61406 1.64406 4.8912 1.97859 4.8912H12.8918C13.1102 4.8912 13.2923 5.07351 13.2923 5.30471V6.55155V13.6418C13.2923 13.873 13.1102 14.0553 12.8918 14.0553H8.72091C8.46339 13.1709 7.67028 12.516 6.72019 12.516C5.7701 12.516 4.97699 13.1709 4.71947 14.0553H3.18962C3.05419 14.0553 2.93934 13.942 2.93934 13.7958V12.8397C2.93934 12.5041 2.67321 12.227 2.33868 12.227C2.00414 12.227 1.73801 12.5041 1.73801 12.8397V14.155C1.73801 14.7739 2.22825 15.2808 2.83923 15.2808H4.71947C4.97699 16.1653 5.7701 16.8201 6.72019 16.8201C7.67028 16.8201 8.46339 16.1653 8.72091 15.2808H13.5616C13.8192 16.1653 14.6123 16.8201 15.5624 16.8201C16.5125 16.8201 17.3056 16.1653 17.5631 15.2808H18.0651C18.6761 15.2808 19.1663 14.7739 19.1663 14.155V10.4958C19.1663 10.2649 19.1301 10.0355 19.0588 9.81644L18.4764 8.02426C18.1911 7.14642 17.3886 6.55155 16.4816 6.55155H14.4936V4.7916C14.4936 4.17265 14.0034 3.66577 13.3924 3.66577H1.97859ZM14.4611 7.77699L14.4843 10.8557H17.965V13.6418C17.965 13.9395 17.8148 14.0553 17.5631 14.0553C17.3056 13.1709 16.5125 12.516 15.5624 12.516C14.5839 12.4999 14.4936 12.9166 14.4936 12.9166L14.4611 7.77699ZM14.4611 7.77699H16.4845C16.8698 7.77699 17.2146 8.02946 17.3385 8.4081L17.7384 9.63023H14.4751L14.4611 7.77699ZM5.8192 14.6681C5.8192 14.1471 6.21916 13.7414 6.72019 13.7414C7.22122 13.7414 7.62118 14.1471 7.62118 14.6681C7.62118 15.189 7.22122 15.5947 6.72019 15.5947C6.21916 15.5947 5.8192 15.189 5.8192 14.6681ZM14.6614 14.6681C14.6614 14.1471 15.0613 13.7414 15.5624 13.7414C16.0634 13.7414 16.4634 14.1471 16.4634 14.6681C16.4634 15.189 16.0634 15.5947 15.5624 15.5947C15.0613 15.5947 14.6614 15.189 14.6614 14.6681Z" fill="#19191B"/>
                            <path d="M12.2688 10.5005C12.4206 10.5005 12.5438 10.6236 12.5438 10.7755V11.1559C12.5438 11.3077 12.4206 11.4309 12.2688 11.4309H10.6726V10.5005H12.2688ZM11.0224 5.83325V11.4309H10.171C10.0191 11.4309 9.896 11.3077 9.896 11.1559V6.10825C9.896 5.95637 10.0191 5.83325 10.171 5.83325H11.0224ZM11.942 8.10152C12.0939 8.10152 12.217 8.22464 12.217 8.37652V8.72998C12.217 8.88186 12.0939 9.00498 11.942 9.00498H10.6726V8.10152H11.942ZM12.2611 5.83325C12.413 5.83325 12.5361 5.95637 12.5361 6.10825V6.49247C12.5361 6.64435 12.413 6.76747 12.2611 6.76747H10.6726V5.83325H12.2611Z" fill="#19191B"/>
                            <path d="M9.20383 10.5005C9.35571 10.5005 9.47883 10.6236 9.47883 10.7755V11.1559C9.47883 11.3077 9.35571 11.4309 9.20383 11.4309H7.60765V10.5005H9.20383ZM7.9575 5.83325V11.4309H7.10605C6.95418 11.4309 6.83105 11.3077 6.83105 11.1559V6.10825C6.83105 5.95637 6.95418 5.83325 7.10605 5.83325H7.9575ZM8.87704 8.10152C9.02892 8.10152 9.15204 8.22464 9.15204 8.37652V8.72998C9.15204 8.88186 9.02892 9.00498 8.87704 9.00498H7.60765V8.10152H8.87704ZM9.19614 5.83325C9.34802 5.83325 9.47114 5.95637 9.47114 6.10825V6.49247C9.47114 6.64435 9.34802 6.76747 9.19614 6.76747H7.60765V5.83325H9.19614Z" fill="#19191B"/>
                            <path d="M2.94922 6.10825C2.94922 5.95637 3.07234 5.83325 3.22422 5.83325H4.46506C4.83926 5.83325 5.15835 5.89733 5.42234 6.02548C5.68633 6.15363 5.88881 6.34329 6.02978 6.59447C6.17074 6.84564 6.24122 7.15577 6.24122 7.52484C6.24122 7.82727 6.20022 8.08614 6.1182 8.30143C6.03618 8.51416 5.91957 8.69229 5.76835 8.83582C5.61713 8.97679 5.43644 9.08956 5.22627 9.17414L4.88411 9.3779H3.42704L3.42319 8.44368H4.4343C4.58808 8.44368 4.71495 8.41036 4.81491 8.34372C4.91743 8.27452 4.99304 8.17841 5.04173 8.05538C5.09299 7.9298 5.11862 7.7837 5.11862 7.61711C5.11862 7.44026 5.09556 7.28904 5.04942 7.16345C5.00585 7.0353 4.93537 6.93791 4.83797 6.87127C4.74314 6.80207 4.61884 6.76747 4.46506 6.76747H4.07401V11.1559C4.07401 11.3077 3.95089 11.4309 3.79901 11.4309H3.22422C3.07234 11.4309 2.94922 11.3077 2.94922 11.1559V6.10825ZM5.39512 11.4309C5.28365 11.4309 5.18321 11.3636 5.1408 11.2605L4.18441 8.93578L5.36467 8.93193L6.254 11.0494C6.33012 11.2306 6.19702 11.4309 6.00046 11.4309H5.39512Z" fill="#19191B"/>
                            <path d="M1.12644 5.83325V11.1559C1.12644 11.3077 1.00332 11.4309 0.851443 11.4309H0.275C0.123122 11.4309 0 11.3077 0 11.1559V6.10825C0 5.95637 0.123122 5.83325 0.275 5.83325H1.12644ZM2.04215 8.21301C2.19402 8.21301 2.31715 8.33613 2.31715 8.48801V8.86838C2.31715 9.02026 2.19402 9.14338 2.04215 9.14338H0.841949V8.21301H2.04215ZM2.25744 5.83325C2.40932 5.83325 2.53244 5.95637 2.53244 6.10825V6.49247C2.53244 6.64435 2.40932 6.76747 2.25744 6.76747H0.841949V5.83325H2.25744Z" fill="#19191B"/>
                        </svg>
                        </span>
                    </div>
                    <div class="slider-bar" id="sliderBar"></div>
                </div>
            </div>
        </div>
    `;
        setTimeout(() => {
            const icon = document.getElementById('icon');
            const offset = 16;
            const sliderBar = document.getElementById('sliderBar');
            const sliderContainer = document.querySelector('.slider-container');
            const sliderHeadingText = document.getElementById('js-delivery-progress-heading-text');
            const successColor = 'rgba(96, 186, 25, 1)';
            if (icon && sliderBar && sliderContainer) {
                const setPosition = (value) => {
                    var _a;
                    const sliderWidth = sliderContainer.offsetWidth;
                    const svgPaths = (_a = document
                        .querySelector('.delivery-progress-bar')) === null || _a === void 0 ? void 0 : _a.querySelectorAll('path');
                    const maxIconPosition = sliderWidth - offset;
                    const iconPosition = Math.min((value / 100) * sliderWidth, maxIconPosition);
                    const isMaxPosition = Math.abs(iconPosition - maxIconPosition) < 1;
                    icon.style.left = `${iconPosition}px`;
                    if (isMaxPosition) {
                        sliderHeadingText.style.color = successColor;
                        icon.style.borderColor = successColor;
                        icon.style.backgroundColor = '#fff';
                        sliderBar.style.background = successColor;
                        svgPaths.forEach((path) => {
                            path.style.fill = successColor;
                        });
                    }
                    else {
                        sliderHeadingText.style.color = '';
                        icon.style.borderColor = '';
                        icon.style.backgroundColor = '';
                        svgPaths.forEach((path) => {
                            path.style.fill = '';
                        });
                        const gradientWidth = (iconPosition / sliderWidth) * 100;
                        sliderBar.style.setProperty('--gradient-width', `${gradientWidth}%`);
                        sliderBar.style.background = `linear-gradient(to right, #fff, #000 ${gradientWidth}%, #E9EAED ${gradientWidth}%)`;
                    }
                };
                setPosition(presetValue);
            }
        }, 0);
        return headerHTML;
    }
    parsePrice(priceString) {
        console.log(priceString);
        const onlyDigits = priceString.replace(/\D/g, '');
        console.log(onlyDigits);
        console.log('s');
        console.log(parseInt(onlyDigits, 10));
        return parseInt(onlyDigits, 10);
    }
    static removeHtmlEntitiesAndNonDigits(str) {
        const withoutEntities = str.replace(/&#\d+;/g, '');
        const digitsOnly = withoutEntities.replace(/\D/g, '');
        const floatValue = parseFloat(digitsOnly);
        return floatValue;
    }
}
